/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import { Modal, Spin } from 'antd'

const noop = () => {}

class WrappedModal extends React.Component {
  formRef = React.createRef()// 创建Form表单
  constructor (props) {
    super(props)
    this.state = {
      open: false,
      confirmLoading: false
    }
  }

  static propTypes = {
    baseComponent: PropTypes.element, // 移除isRequired
    baseProps: PropTypes.object,
    style: PropTypes.object,
    title: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    mask: PropTypes.bool,
    maskClosable: PropTypes.bool,
    destroyOnClose: PropTypes.bool,
    closable: PropTypes.bool,
    footer: PropTypes.node,
    okText: PropTypes.string,
    okType: PropTypes.string,
    cancelText: PropTypes.string,
    onOk: PropTypes.func,
    onCancel: PropTypes.func,
    children: PropTypes.node, // 添加children类型定义
    centerTitle: PropTypes.bool
  }

  static defaultProps = {
    style: {}, // 还原为空对象，按钮样式应该在调用处设置
    maskClosable: false,
    destroyOnClose: true,
    form: { current: {} },
    okText: '确定',
    cancelText: '取消',
    onOk: noop,
    onCancel: noop,
    baseComponent: null, // 添加baseComponent默认值
    children: null, // 添加children默认值
    centerTitle: false
  }

  componentWillUnmount () {
    this.cancelled = true
  }

  showModal = e => {
    e.stopPropagation()
    const { disabledModal } = this.props
    if (disabledModal) {
      this.setState({ open: false })
      return
    }
    this.setState({ open: true })
  }

  hideModal = async (e) => {
    try {
      const htmlTarger = /HTML/.test(`${e.target}`)
      if (this.props.onCancel && htmlTarger) {
        this.setState({ confirmLoading: true })
        await Promise.resolve(this.props.onCancel(this.formRef.current))
      }
      if (this.formRef.current){
        this.formRef.current.resetFields()
      }
      this.setState({ confirmLoading: false, open: false })
    } catch (error) {
      this.setState({
        confirmLoading: false
      })
      console.log('wrapModal onCancel error: ', error)
    }
  }

  handleOk = async () => {
    try {
      this.setState({ confirmLoading: true })
      // 连同 form 方法 一并抛出
      await Promise.resolve(this.props.onOk(this.formRef))
      if (!this.cancelled) {
        this.setState({ confirmLoading: false, open: false })
      }
    } catch (error) {
      this.setState({ confirmLoading: false })
      console.log('wrapModal handleOk error: ', error)
    }
  }

  render () {
    const { open, confirmLoading } = this.state
    const { children, baseProps, baseComponent, centerTitle, className, ...modalProps } = this.props

    // 安全检查，确保baseComponent存在
    const modalContent = baseComponent ? (
      <Spin spinning={confirmLoading}>
        {React.cloneElement(baseComponent, {
          ...baseComponent.props,
          ...baseProps,
          form: this.formRef
        })}
      </Spin>
    ) : null

    const modal = (
      <Modal
        {...modalProps}
        confirmLoading={confirmLoading}
        open={open}
        onOk={this.handleOk}
        onCancel={this.hideModal}
        className={className}
      >
        {modalContent}
      </Modal>
    )

    // 安全检查，确保children存在
    return (
        <span onClick={(e) => e.stopPropagation()} >
          {children && React.cloneElement(children, {
            key: 'trigger', // 修复拼写错误
            onClick: this.showModal
          })}
          {modal}
        </span>
    )
  }
}

export default WrappedModal